<template>
  <div class="transaction">
    <header-page> Transaksi </header-page>
    <div class="transaction__filter--container py-1">
      <div class="row mx-0 justify-content-between w-100 flex-lg-row flex-column-reverse">
        <b-col cols="12" md="5" lg="5">
          <b-button-group>
            <b-button v-for="(item, index) in listFilter" :key="`${item}-${index}`" :id="`button__filter__${index}`"
              class="filter--button" :class="{ active: item.name == filters }"
              @click="(status = item.value), (filters = item.name), ($router.push({ name: $route.name,
                params: $route.params,
                query: {
                  ...$route.query,
                  comp: item.name
                } }))">
              {{ item.name }}
            </b-button>
          </b-button-group>
        </b-col>
        <b-col cols="12" md="7" lg="7" class="d-flex search__export justify-content-end">
          <div class="search__input">
            <b-input-group>
              <b-form-input v-model="filter.search" placeholder="Cari nama pembeli atau nomor invoice" />
              <b-input-group-append is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-append>
            </b-input-group>
          </div>

          <!-- <b-button variant="outline-secondary py-1 bg-white mx-1">
            <b-img :src="require('../../assets/images/icons/export.svg')" />
            <span>Export</span>
          </b-button> -->
          <FilterButton @filterBase="getFilterBase" :is_transaction="true" :get-data="getData" />
        </b-col>
      </div>
    </div>

    <div class="d-flex justify-content-center mb-1 mt-3" v-if="isLoading">
      <b-spinner label="Loading..." />
    </div>
    <vue-good-table v-else style="z-index: 0;" max-height="80vh" :columns="columns" :rows="computedItems" :isLoading.sync="isLoadingSortBy" :fixed-header="false" :search-options="{
      enabled: false,
    }" :sort-options="{
      enabled: false,
    }" :pagination-options="{
        enabled: false,
      }">
      <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field == 'action'">
          <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle" />
        </span>

        <span v-else-if="props.column.field == 'invoice_number'">
          <div class="d-flex">
            <span class="mr-1">
              {{ props.column.label }}
            </span>
            <b-img class="filter-image" :class="sortType[0].sortBy == 'asc' ? 'rotate-180' : ''"
              :src="require('@/assets/images/icons/Icon-order-list-down.svg')" alt="Icon-order-list-down" role="button"
              @click="handleSort('invoice_number', 'desc')" />
          </div>
        </span>
        <span v-else-if="props.column.field == 'status'">
          <div class="d-flex">
            <span class="mr-1">
              {{ props.column.label }}
            </span>
            <b-img class="filter-image" :class="sortType[1].sortBy == 'asc' ? 'rotate-180' : ''"
              :src="require('@/assets/images/icons/Icon-order-list-down.svg')" alt="Icon-order-list-down" role="button"
              @click="handleSort('status', 'desc')" />
          </div>
        </span>
        <span v-else-if="props.column.field == 'date'">
          <div class="d-flex">
            <span class="mr-1">
              {{ props.column.label }}
            </span>
            <b-img class="filter-image" :class="sortType[2].sortBy == 'asc' ? 'rotate-180' : ''"
              :src="require('@/assets/images/icons/Icon-order-list-down.svg')" alt="Icon-order-list-down" role="button"
              @click="handleSort('date', 'desc')" />
          </div>
        </span>
        <span v-else-if="props.column.field == 'customer.name'">
          <div class="d-flex">
            <span class="mr-1">
              {{ props.column.label }}
            </span>
            <b-img class="filter-image" :class="sortType[3].sortBy == 'asc' ? 'rotate-180' : ''"
              :src="require('@/assets/images/icons/Icon-order-list-down.svg')" alt="Icon-order-list-down" role="button"
              @click="handleSort('customer.name', 'desc')" />
          </div>
        </span>
        <span v-else-if="props.column.field == 'operator.name'">
          <div class="d-flex">
            <span class="mr-1">
              {{ props.column.label }}
            </span>
            <b-img class="filter-image" :class="sortType[4].sortBy == 'asc' ? 'rotate-180' : ''"
              :src="require('@/assets/images/icons/Icon-order-list-down.svg')" alt="Icon-order-list-down" role="button"
              @click="handleSort('operator.name', 'desc')" />
          </div>
        </span>
        <span v-else-if="props.column.field == 'seller.name'">
          <div class="d-flex">
            <span class="mr-1">
              {{ props.column.label }}
            </span>
            <b-img class="filter-image" :class="sortType[5].sortBy == 'asc' ? 'rotate-180' : ''"
              :src="require('@/assets/images/icons/Icon-order-list-down.svg')" alt="Icon-order-list-down" role="button"
              @click="handleSort('operator.name', 'desc')" />
          </div>
        </span>
      </template>

      <template slot="table-row" slot-scope="props">
        <!-- Column: Pembeli -->
        <span v-if="props.column.field === 'customer.name'">
          <span>{{
            (props.row.customer && props.row.customer.name) || "-"
          }}</span>
        </span>

        <span v-else-if="props.column.field === 'invoice_number'">
          <span class="text-danger cursor-pointer" @click="getDetail(props.row.uuid)">
            {{ props.row.invoice_number || "-" }}
          </span>
        </span>

        <!-- Column: Total -->
        <span v-else-if="props.column.field === 'total'">
          <span>{{ props.row.total | formatAmount }}</span>
        </span>

        <!-- Column: Payment -->
        <span v-else-if="props.column.field === 'payment_method'">
          <span class="text-capitalize">{{
            props.row.payments.map((e) => getLabel(e.payment_method)).join(", ")
          }}</span>
        </span>

        <!-- Column: Sales -->
        <span v-else-if="props.column.field === 'seller'">
          <span class="text-capitalize">{{
            (props.row.seller && props.row.seller.name) || "-"
          }}</span>
        </span>

        <!-- Column: Kasir -->
        <span v-else-if="props.column.field === 'operator.name'">
          <span class="text-capitalize">{{
            (props.row.operator && props.row.operator.name) || "-"
          }}</span>
        </span>
        <!-- Column: Action By -->
        <span v-else-if="props.column.field === 'action_by'">
          <span class="text-capitalize">{{ props.row.action_by && props.row.action_by.name || '-' }}</span>
        </span>

        <!-- Column: Sales -->
        <span v-else-if="props.column.field === 'action_time'">
          <span class="text-capitalize">{{ props.row.action_time && props.row.action_time | formatDateWithTime }}</span>
        </span>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'status'" class="text-capitalize">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ getStatusLabel(props.row.status) }}
          </b-badge>
        </span>

        <!-- Column: Returs -->
        <span v-else-if="props.column.field === 'returs'" class="text-capitalize">
          <span v-if="props.row.returs.length">
            <span v-for="retur, index in props.row.returs" :key="index">
              <b-link @click="detailItem(retur.uuid)">
                <span class="text-danger">
                  {{ retur.retur_number || '-' }}
                </span>
              </b-link>
              <span v-if="index < props.row.returs.length - 1">, </span>
            </span>
          </span>
          <span v-else>-</span>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown id="dropdown-dropleft" class="d-flex" right v-if="props.row.status !== 'canceled'">
              <template #button-content class="btn-white text-center">
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle" />
              </template>
              <!-- <b-dropdown-item @click="$router.push({ name: 'invoice.index', params: { id: props.row.uuid }, query: { type: 'show_transaction' } })">
                Lihat Transaksi
              </b-dropdown-item> -->
              <!-- <b-dropdown-item v-if="checkPermission('edit transaksi')" @click="$router.push({ name: 'transaction.show', params: { id: props.row.uuid } })">
                Edit Transaksi
              </b-dropdown-item> -->
              <b-dropdown-item @click="goToDetail(props)">
                Lihat Invoice
              </b-dropdown-item>
              <b-dropdown-item @click="getDetailTransfer(props.row.uuid)"
                v-if="props.row.payments.map((e) => e.payment_method).includes('transfer')">
                <b-spinner v-if="isLoading" />
                Lihat Bukti Transfer
              </b-dropdown-item>
              <b-dropdown-item @click="returOrder(props.row.uuid)"
                v-if="checkPermission('add retur')">
                <b-spinner v-if="isLoading" />
                Retur
              </b-dropdown-item>
              <!-- <b-dropdown-item @click="deleteOrder(props.row)"
                v-if="checkPermission('batalkan transaksi')">
                <b-spinner v-if="isLoading" />
                Batalkan Transaksi
              </b-dropdown-item> -->
              <b-dropdown-item @click="deleteOrder(props.row)"
                v-if="checkPermission('batalkan transaksi')">
                <b-spinner v-if="isLoading" />
                Batalkan Transaksi
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <!-- Pagination -->
    <div v-if="rows && !isLoading" class="d-flex justify-content-between align-items-center flex-wrap bg-white border"
      style="padding: 0.8rem">
      <div class="d-flex align-items-center">
        <b-form-select v-model="filter.per_page" :options="['10', '15', '20']" class="mx-1" />
        <span class="text-nowrap">
          Tampilkan
          {{
            rows.total > 0 ? filter.per_page * (rows.current_page - 1) + 1 : 0
          }}
          ke
          {{
            rows.total > 0
              ? Math.min(filter.per_page * rows.current_page, rows.total)
              : 0
          }}
          dari {{ rows.total }} transaksi.
        </span>
      </div>
      <div>
        <b-row class="mx-0 align-items-center">
          <b-col>
            <pagination class="mb-0" :data="rows" :limit="4" align="right" @pagination-change-page="getData" />
          </b-col>
        </b-row>
      </div>
    </div>
    <ModalRetur :is_edit="false" :returType="'order'" :results="returData" :getData="getData" />
    <ModalEditTransaction />
    <DetailHistoryTransaction :historyDetail="historyDetail" :delivery-numbers="deliveryNumbers" />
    <b-modal
      id="modal-detail-transfer"
      title="Detail Transfer"
      ok-only
      ok-title="Close"
      size="xl"
      @hidden="resetModalDetailTransfer"
    >
      <div class="d-flex justify-content-center">
        <b-spinner v-if="isLoadingDetailTransfer" label="Loading..." />
      </div>

      <div v-if="!isLoadingDetailTransfer">
        <div v-for="(payment, index) in detailTransfer.payments" :key="index">
          <b-row class="invoice-spacing">
            <!-- Rekening Pengirim -->
            <b-col
              xl="6"
              cols="12"
            >
              <div>
                 <h6 class="mb-1">
                    Rekening Pengirim:
                  </h6>
                <table>
                  <tbody>
                    <tr>
                      <td class="pr-1">
                        Nama pengirim
                      </td>
                      <td>: {{ payment.bank_account_name }}</td>
                    </tr>
                    <tr>
                      <td class="pr-1">
                        Nomor rekening pengirim
                      </td>
                      <td>: {{ payment.bank_account_number }}</td>
                    </tr>
                    <tr>
                      <td class="pr-1">
                        Bank pengirim
                      </td>
                      <td>: {{ payment.bank_name }}</td>
                    </tr>
                    <tr>
                      <td class="pr-1">
                        Metode pembayaran
                      </td>
                      <td>
                        <span class="text-capitalize">: {{ payment.payment_method }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pr-1">
                        Bukti transfer
                      </td>
                      <td>
                        : <a :href="payment.bank_transfer_attachment" target="_blank" v-if="payment.bank_transfer_attachment">
                          Klik disini
                        </a>
                        <span v-else>-</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pr-1">
                        Total
                      </td>
                      <td>
                        : <span class="font-weight-bolder">{{ payment.amount | formatAmount }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
            <!-- Rekening Penerima -->
            <b-col
              xl="6"
              cols="12"
              class="mt-2 mt-md-2 mt-lg-2 mt-xl-0"
            >
              <div>
                 <h6 class="mb-1">
                    Rekening Penerima:
                  </h6>
                <table>
                  <tbody>
                    <tr>
                      <td class="pr-1">
                        Nama penerima
                      </td>
                      <td>: {{ payment.bank_account_payment && payment.bank_account_payment.owner_name }}</td>
                    </tr>
                    <tr>
                      <td class="pr-1">
                        Nomor rekening penerima
                      </td>
                      <td>: {{ payment.bank_account_payment && payment.bank_account_payment.account_number }}</td>
                    </tr>
                    <tr>
                      <td class="pr-1">
                        Bank penerima
                      </td>
                      <td>: {{ payment.bank_account_payment && payment.bank_account_payment.bank.name }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      id="modal-detail-retur"
      centered
      hide-footer
      title="Detail Retur"
      @show="handleOpenModalRetur"
    >
      <b-overlay
        :show="isLoadingRetur"
        rounded="sm"
        no-fade
      >
        <b-container id="contentPrint" class="h-100 bg-wave">
          <div class="px-lg-1 px-1 pb-3">
              <!-- Logo -->
              <b-img 
                  v-if="hasValidPhoto" 
                  :src="photoRetur" 
                  alt="logo" 
                  class="custom-img"
                  style="margin-left: 145px; width: 100px; height: auto;" 
              />

              <!-- Detail -->
              <b-row class="mt-2">
                  <b-col lg="12">
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0" v-if="detailRetur.type === 'order'">
                          No. Invoice: {{ detailRetur.transaction.invoice_number || '-' }}
                      </h6>
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0">
                          No. Retur: {{ detailRetur.retur_number || '-' }}
                      </h6>
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0">
                          Tanggal: {{ detailRetur.date || '-' }}
                      </h6>
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0" v-if="detailRetur.type === 'order'">
                          Sales: {{ detailRetur.transaction.seller_name || '-' }}
                      </h6>
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0" v-if="detailRetur.type === 'order'">
                          Pelanggan: {{ detailRetur.transaction.customer_name || '-' }}
                      </h6>
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0"
                          v-else-if="detailRetur.type === 'incoming_stock'">
                          Pemasok: {{ detailRetur.transaction.supplier_name || '-' }}
                      </h6>
                      <h6 v-if="formattedCreatedAt" class="size10 text-black mb-1 font-italic fw-bold-500" style="margin-top: 8px;">
                        Dibuat: {{ formattedCreatedAt }}
                      </h6>
                  </b-col>
                  <b-col lg="12">
                      <hr class="mb-25" style="border-top: 1px solid #000;">
                  </b-col>
              </b-row>

              <!-- List Produk -->
              <b-row>
                  <b-col lg="12">
                      <div v-for="(item, index) in detailRetur.items" :key="index" class="mb-25">
                          <div class="d-flex" style="height: 2rem">
                              <h6 class="size10 fw-bold-700 text-black px-0" v-if="detailRetur.type === 'order'">
                                  {{ item.item && item.item.name }}
                              </h6>
                              <h6 class="size10 fw-bold-700 text-black px-0" v-else-if="detailRetur.type === 'incoming_stock'">
                                  {{ item.item && item.item.product.name }}
                              </h6>
                          </div>
                          <div class="d-flex" style="height: 2rem">
                              <h6 class="size10 fw-bold-500 text-black col-3 px-0"
                                  v-if="detailRetur.type === 'order'">
                                  {{ item.return_qty.toString().replace('.', ',') }} {{
                                      item.item && item.item.unit }}
                              </h6>
                              <h6 class="size10 fw-bold-500 text-black col-3 px-0" v-else>
                                  {{ item.return_qty.toString().replace('.', ',') }} {{
                                      item.item && item.item.product.uom.name }}
                              </h6>
                              <h6 class="size10 fw-bold-500 text-black col-3 px-0">
                                  {{ item.item && item.item.price | formatInvoice }}
                              </h6>
                              <h6 class="size10 fw-bold-500 text-black col-3 px-0 text-right">
                                  {{ item.return_value | formatInvoice }}
                              </h6>
                          </div>
                      </div>
                  </b-col>
                  <b-col lg="12">
                      <hr class="mt-25" style="border-top: 1px solid #000;">
                  </b-col>
              </b-row>
              <!-- <hr class="my-0" style="border-top: 1px solid #000;"> -->

              <!-- Total Retur -->
              <b-row>
                  <b-col lg="12">
                      <div class="d-flex justify-content-between" style="margin-bottom: 0.5rem;">
                          <h6 class="text-black size12 mb-0 fw-bold-700">
                              Total Diskon Retur
                          </h6>
                          <h6 class="text-black size10 mb-0 fw-bold-700">
                              {{ detailRetur.discount | formatAmount }}
                          </h6>
                      </div>
                      <div v-if="!detailRetur.is_split_payment_method">
                          <div class="d-flex justify-content-between" style="margin-bottom: 0.5rem;">
                              <h6 class="text-black size12 mb-0 fw-bold-700">
                                  {{ getLabel(detailRetur.payment_method) }}
                              </h6>
                              <h6 class="text-black size10 mb-0 fw-bold-700">
                                  {{ detailRetur.return_value | formatAmount }}
                              </h6>
                          </div>
                      </div>
                      <div v-if="detailRetur.is_split_payment_method">
                          <div v-for="(payment, index) in detailRetur.payment_method_details" :key="index" class="d-flex justify-content-between" style="margin-bottom: 0.5rem;">
                              <h6 class="text-black size12 mb-0 fw-bold-700">
                                  {{ getLabel(payment.payment_method) }}
                              </h6>
                              <h6 class="text-black size10 mb-0 fw-bold-700">
                                  {{ payment.amount | formatAmount }}
                              </h6>
                          </div>
                      </div>
                      <div class="d-flex justify-content-between" style="margin-bottom: 0.5rem;">
                          <h6 class="text-black size12 mb-0 fw-bold-700">
                              Total Retur
                          </h6>
                          <h6 class="text-black size10 mb-0 fw-bold-700">
                              {{ (detailRetur.return_value - (detailRetur.discount || 0)) | formatAmount }}
                          </h6>
                      </div>
                  </b-col>
              </b-row>
          </div>
        </b-container>
      </b-overlay>
    </b-modal>

    <!-- Modal Cancel Order -->
    <b-modal
      id="modal-cancel-order"
      cancel-variant="outline-secondary"
      hide-header
      hide-footer      
      centered
      no-close-on-backdrop
      size="sm"
    >
      <div v-if="isLoadingCancelOrder">
        <div class="d-flex justify-content-center" >
          <b-spinner label="Loading..." />
        </div>
      </div>
      <div v-if="!isLoadingCancelOrder && formPayloadCancelSplitOrders && formPayloadCancelSplitOrders.refund_method_detail.length">
        <div class="d-flex flex-column align-items-center justify-content-center text-center mb-2">
          <feather-icon icon="AlertCircleIcon" size="72" class="text-warning font-weight-bolder my-2" />
          <span class="text-dark size20 fw-bold-700 mb-25">Konfirmasi</span>
          <span class="text-dark size16 fw-bold-500">Apa anda yakin ingin membatalkan transaksi ini?</span>
        </div>
  
        <b-row class="mb-2 mx-0" v-for="(detail, index) in userPayments" :key="index">
          <b-col cols="6">
            <b-form-select
              v-model="formPayloadCancelSplitOrders.refund_method_detail[index].method"
              :disabled="priorityPayment.filter(method => {
                if (method === 'piutang' && detail.method === 'piutang' && detail.unpaid === 0) {
                  return false
                }
                return true
              })
              .some(method => method === detail.method)"
            >
              <b-form-select-option v-for="(option, indexOption) in options.optionsBank" :key="indexOption" :value="option.value" 
                :disabled="(
                    // ✅ Jika metode sekarang tunai/transfer → disable piutang, point, giro
                    ['piutang', 'point', 'card', 'giro'].some(val => val === option.value) &&
                    ['cash', 'transfer', 'wallet', 'card', 'giro'].includes(detail.method)
                  )
                  ||
                  (
                    // ✅ Jika metode sekarang piutang dan sudah lunas → disable opsi piutang
                    detail.method === 'piutang' && detail.unpaid === 0 && option.value === 'piutang'
                  )"
                >{{ option.text }}</b-form-select-option>
            </b-form-select>
          </b-col>

          <b-col cols="6">
            <b-form-group label="" class="mb-0">
              <b-form-input :value="detail.amount" disabled />
            </b-form-group>
          </b-col>
        </b-row>
  
        <div class="d-flex justify-content-center">
          <b-button
            variant="primary"
            class="mr-1"
            @click="submitCancelSplitOrders"
          >
            Ok
          </b-button>
          <b-button
            variant="outline-danger"
            class=""
            @click="$bvModal.hide('modal-cancel-order')"
          >
            Cancel
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from "moment";
import _ from "lodash";
import {
  BRow,
  BCol,
  BFormInput,
  BButton,
  BButtonGroup,
  BDropdown,
  BDropdownItem,
  BBadge,
  BImg,
  BInputGroup,
  BInputGroupAppend,
  BFormSelect,
  BSpinner,
  BModal,
  BLink,
  BContainer, 
  BOverlay,
  BFormGroup,
  BFormSelectOption,
} from "bootstrap-vue";
import { checkPermission, errorNotification } from "@/auth/utils";
import { VueGoodTable } from "vue-good-table";
import FilterButton from "@/components/BaseFilter.vue";
import HeaderPage from "@/components/HeaderPage.vue";
import DetailHistoryTransaction from "@/components/Transaction/Modal/DetailHistoryTransaction.vue";
import ModalEditTransaction from "@/components/Transaction/Modal/EditTransaksi.vue";
import ModalRetur from "@/components/Retur/Modal/ModalRetur.vue";

import vSelect from "vue-select";

export default {
  title() {
    return "Riwayat Transaksi";
  },
  components: {
    BRow,
    VueGoodTable,
    BButton,
    BFormInput,
    HeaderPage,
    BButtonGroup,
    BDropdown,
    BDropdownItem,
    BBadge,
    BImg,
    BInputGroup,
    BInputGroupAppend,
    BFormSelect,
    ModalEditTransaction,
    DetailHistoryTransaction,
    BCol,
    ModalRetur,
    BSpinner,
    FilterButton,
    BModal,
    BLink,
    BContainer, 
    BOverlay,
    vSelect,
    BFormGroup,
    BFormSelectOption,
  },
  setup() {
    return {
      checkPermission,
      errorNotification,
    };
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "No. Invoice",
          field: "invoice_number",
        },
        {
          label: "Jumlah",
          field: "total",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Retur",
          field: "returs",
        },
        {
          label: "Metode Bayar",
          field: "payment_method",
        },
        {
          label: "Kasir",
          field: "operator.name",
        },
        {
          label: "Pembeli",
          field: "customer.name",
        },
        {
          label: "Sales",
          field: "seller",
        },
        {
          label: "Tanggal",
          field: "date",
        },
        {
          label: 'Dibatalkan Oleh',
          field: 'action_by',
        },
        {
          label: 'Tanggal Dibatalkan',
          field: 'action_time',
        },
        {
          label: 'Metode Pengembalian Dana',
          field: 'refund_method_display',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: {},
      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
      totalBuy: this.$store.state.cashier.totalBuy,
      listFilter: [
        {
          name: "Semua",
          value: "",
        },
        {
          name: "Lunas",
          value: "success",
        },
        {
          name: "Belum Lunas",
          value: "pending",
        },
        // {
        //   name: 'Retur',
        //   value: 'retur',
        // },
        // 'Semua', 'Lunas', 'Belum Lunas', 'Retur'
      ],
      filters: "Semua",
      filter: {
        status: "",
        search: "",
        sort_type: 'desc',
        per_page: 10,
        sort_column: null
      },
      optionsBank: [
        { value: "cash", title: "Tunai" },
        { value: "transfer", title: "Transfer" },
        { value: "giro", title: "Giro" },
        { value: "piutang", title: "Piutang" },
        { value: "wallet", title: "Deposit" },
        { value: "point", title: "Customer Point" },
        // { value: "card", title: "Kredit Atau Debit" },
      ],
      isLoading: false,
      returData: null,
      status: "",
      page: 1,
      items: [],
      historyDetail: {},
      deliveryNumbers: [],
      detailTransfer: {},
      isLoadingDetailTransfer: false,
      isLoadingSortBy: false,
      sortType: [
        {
          type: 'invoice_number',
          sortBy: 'desc'
        },
        {
          type: 'status',
          sortBy: 'desc'
        },
        {
          type: 'date',
          sortBy: 'desc'
        },
        {
          type: 'customer.name',
          sortBy: 'desc'
        },
        {
          type: 'operator.name',
          sortBy: 'desc'
        },
        {
          type: 'seller.name',
          sortBy: 'desc'
        },
      ],
      detailRetur: {},
      merchant: {},
      returnUuid: null,
      isLoadingRetur: false,
      options: {
        optionsBank: [
          { value: "cash", text: "Tunai" },
          { value: "transfer", text: "Transfer" },
          { value: "wallet", text: "Deposit" },
          { value: "giro", text: "Giro" },
          { value: "piutang", text: "Piutang" },
          { value: "point", text: "Customer Point" },
          // { value: "card", text: "Kredit Atau Debit" },
        ]
      },
      userPayments: [],
      isLoadingCancelOrder: false,
      formPayloadCancelSplitOrders: {
        is_split_refund: false,
        refund_method: '',
        refund_method_details: '',
        refund_method_detail: []
      },
      priorityPayment:["point", "piutang"],
      uuid: null,
      moment,
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        success: "light-success",
        pending: "light-info",
        Retur: "light-warning",
        canceled: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    hasValidPhoto() {
        const photoUrl = this.detailRetur?.transaction?.branch?.photo_url;
        if (!photoUrl) return false;
        return ['png', 'jpg'].some(ext => photoUrl.includes(ext));
    },
    photoRetur() {
      return this.detailRetur?.transaction?.branch?.photo_url || null;
    },
    formattedCreatedAt() {
      const createdAt = this.detailRetur?.created_at || this.detailRetur?.date;
      if (!createdAt) return '';
      return moment(createdAt).format('DD/MMM/YYYY HH:mm:ss');
    },
    computedItems() {
      if (!this.items?.length) return []

      return this.items.map(row => {

        let refundDisplay = '-'

        if (!row.is_split_refund) {
          refundDisplay = row.refund_method
            ? this.getLabel(row.refund_method)
            : '-'
        } else if (row.refund_method_details?.length) {
          refundDisplay = row.refund_method_details
            .map(r => {
              const label = this.getLabel(r.method)
              const amount = this.$options.filters.formatAmount(r.amount)
              return `${label} (${amount})`
            })
            .join(', ')
        }

        return {
          ...row,
          refund_method_display: refundDisplay
        }
      })
    }
  },
  watch: {
    status: {
      handler: _.debounce(function (val) {
        this.filter.status = val;
        this.getData();
      }, 300),
      deep: true,
    },
    "filter.search": {
      handler: _.debounce(function (val) {
        this.getData();
      }, 300),
      deep: true,
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    const status = {
      "Lunas": 'success',
      "Belum Lunas": 'pending'
    }
    const comp = this.$route.query.comp

    if (comp) {
      this.filters = comp
      this.status = status[comp]
    }
  },
  methods: {
    handleOpenModalRetur() {
      this.getDetailRetur()
      this.getMerchant()
    },
    getDetailRetur() {
      this.isLoadingRetur = true
      this.$store.dispatch(`returs/getData`, {
          uuid: this.returnUuid,
      })
        .then(result => {
            this.detailRetur = result.data.data;
            this.isLoadingRetur = false
        }).catch(err => {
          this.isLoadingRetur = false
            console.log(err);
        });
    },
    getMerchant() {
        this.$store.dispatch('profile/getMerchant')
            .then(result => {
                this.merchant = result.data.data;
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.log(err)
            })
    },
    handleSort(type, currentSortOrder, page = this.$route.query.page || 1) {
      // Toggle sort order based on the current sort order
      const sortOrder = currentSortOrder === 'asc' ? 'desc' : 'asc';
      this.isLoadingSortBy = true
      // Construct the query params for the API call
      const queryParams = {
        page,
        sort_column: type,
        sort_type: sortOrder
      };

      // Update the component's state for sorting
      this.page = page;
      this.sortType = this.sortType.map(item => {
        if (item.type === type) {
          const newSortOrder = item.sortBy === 'asc' ? 'desc' : 'asc';
          queryParams.sort_type = newSortOrder
          return {
            ...item,
            sortBy: newSortOrder // Update sortBy for the matching type
          };
        }
        return item; // Return the other types unchanged
      });

      if (this.$route.query.date) {
        queryParams.filter_date_type = "date";
        queryParams.filter_date_value = this.$route.query.date;
      }

      if (this.$route.query.payment_method) {
        queryParams.transactionMethod = [this.$route.query.payment_method];
      }

      // Set the page number
      queryParams.page = page;
      this.page = page;

      // Ensure paymentMethod is an array
      const paymentMethods = Array.isArray(queryParams.transactionMethod)
        ? queryParams.transactionMethod
        : [];
      delete queryParams.transactionMethod;

      // Construct the final params object
      const finalParams = {
        ...queryParams,
        ...paymentMethods.reduce((acc, method, index) => {
          acc[`payment_method[${index}]`] = method;
          return acc;
        }, {}),
      };

      this.filter = {
        ...this.filter,
        ...finalParams
      }

      this.$store
        .dispatch("order/getData", {
          uuid: "",
          params: finalParams,
        })
        .then((result) => {
          this.isLoadingSortBy = false
          this.rows = result.data.data;
          this.items = result.data.data.data;
          
        })
        .catch((err) => {
          this.isLoadingSortBy = false
          if (err.response.data.meta.messages) {
            errorNotification(this, "Oops!", err.response.data.meta.messages);
          }
          console.log(err);          
        });
    },
    getStatusLabel(status) {
      const statusLabels = {
        success: "Lunas",
        canceled: "Dibatalkan",
      };
      return statusLabels[status] || "Belum Lunas";
    },
    resetModalDetailTransfer() {
      this.detailTransfer = {}
    },
    async getDetailTransfer(uuid) {
      this.isLoadingDetailTransfer = true
      this.$bvModal.show('modal-detail-transfer')
      try {
        const response = await this.$http.get(`/order/${uuid}/detail`);
        this.isLoadingDetailTransfer = false
        this.detailTransfer = response.data.data
      } catch (error) {
        this.isLoadingDetailTransfer = false
      }
    },
    getFilterBase(value) {
      this.$router.replace({ query: { date: this.$route.query.date, payment_method: this.$route.query.payment_method } });

      this.filter = {
        ...value,
      };
    },
    getLabel(payment) {
      const payments = {
        tunai: "Tunai",
        transfer: "Transfer Bank",
        card: "Kredit atau Debit",
        giro: "Giro",
        wallet: "Deposit",
        piutang: "Piutang",
        cash: "Tunai",
        point: "Customer Point",
        // card: "Kredit Atau Debit",
      };
      return payments[payment] || "-";
    },
    async getDetail(id) {
      this.$store
        .dispatch("order/getData", {
          uuid: `${id}/detail`,
          params: "",
        })
        .then((result) => {
          this.historyDetail = result.data.data;
          result.data.data.items.forEach((element) => {
            if (element.delivery_numbers.length) {
              this.deliveryNumbers.push(
                ...element.delivery_numbers.map((e) => e.delivery_number_note)
              );
            }
          });
          this.$bvModal.show("modal-history-detail");
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          if (err.response.data.meta.messages) {
            errorNotification(this, "Oops!", err.response.data.meta.messages);
          }
        });
    },
    deleteOrder(item) {
      console.log(item, 'ITEM')
      const id = item.uuid
      this.uuid = id
      const paymentLength = item.payments.length
      const isSuccess = item.status === 'success'
      const customer = item.customer

      if (paymentLength === 1) {
        const payment = item.payments[0]
        const paymentMethod = payment.payment_method  // <-- metode pembayaran utama

        this.$swal({
          title: "Konfirmasi",
          text: "Apa Anda yakin ingin membatalkan transaksi ini?",
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
          input: "select",
          inputOptions: {}, 
          inputPlaceholder: "Pilih metode pembayaran untuk refund",
          didOpen: () => {
            const select = this.$swal.getInput();
            select.innerHTML = this.optionsBank
              .map(option => `
                <option
                  value="${option.value}"
                  ${this.isOptionDisabled(paymentMethod, isSuccess, option, customer) ? 'disabled' : ''} 
                >
                  ${option.title}
                </option>
              `)
              .join(""); // Note: Pass 'customer' as the 4th argument above ^
          },
          inputValidator: (value) => {
            if (!value) {
              return "Anda harus memilih metode pembayaran untuk refund!";
            }
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const refundMethod = result.value;
            this.isLoading = true;
            this.$store
              .dispatch("order/deleteData", {
                uuid: `${id}/delete`,
                payload: { 
                  refund_method: refundMethod, 
                  refund_method_details: JSON.stringify([refundMethod]),
                  is_split_refund: false 
                },
              })
              .then(() => {
                this.isLoading = false;
                this.$swal({
                  icon: "success",
                  title: "Success!",
                  text: "Order berhasil dibatalkan",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                this.getData();
                window.location.reload()
              })
              .catch((err) => {
                this.isLoading = false;
                // eslint-disable-next-line no-console
                console.log(err);
              });
          }
        });
      }

      if (paymentLength > 1) {
        this.isLoadingCancelOrder = true
        this.$bvModal.show('modal-cancel-order')

        const PRIORITY = ["point", "piutang", "wallet"];
        
        function sortByPriority(arr, key, priority = PRIORITY) {
          const rank = new Map(priority.map((v, i) => [v, i]));
          return arr.slice().sort((a, b) => {
            const ar = rank.get(a[key]);
            const br = rank.get(b[key]);
            if (ar === undefined && br === undefined) return 0;
            if (ar === undefined) return 1;
            if (br === undefined) return -1;
            return ar - br;
          });
        }

        this.$store
        .dispatch("order/getData", {
          uuid: `${id}/detail`,
          params: "",
        })
        .then((result) => {
          const data = result.data.data
          this.isLoadingCancelOrder = false
          this.userPayments = sortByPriority(data.payments.map(({ payment_method, amount, unpaid }) => ({
                method: payment_method,
                amount,
                unpaid: unpaid || 0
              })), "method");

          this.formPayloadCancelSplitOrders = {
            is_split_refund: true,
            refund_method: '',
            refund_method_details: '',
            refund_method_detail: sortByPriority(
              data.payments.map(({ payment_method, amount, unpaid }) => {
                // ✅ Jika piutang sudah lunas, ubah ke cash
                const isPiutangPaidOff = payment_method === "piutang" && (unpaid || 0) === 0;
                const isCardOrGiro = ["card", "giro"].includes(payment_method);

                return {
                  method: isPiutangPaidOff || isCardOrGiro ? "cash" : payment_method,
                  amount,
                  unpaid: unpaid || 0
                }
              }),
              "method"
            )
          }
        })
        .catch((err) => {
          this.isLoadingCancelOrder = false
          // eslint-disable-next-line no-console
          console.log(err);
        })
        // this.userPayments = item.payments
      }
    },
    isOptionDisabled(paymentMethod, isSuccess, option, customer) {
      const val = option.value

      // ✅ NEW LOGIC: Disable wallet if customer is null/empty
      if (val === 'wallet' && !customer) {
        return true
      }

      // if cash disabled piutang, point, and giro
      if (paymentMethod === 'cash') {
        return ['piutang', 'point', 'giro'].includes(val)
      }

      // if transfer or wallet, or giro disabled piutang, point, and giro
      if (['transfer', 'wallet', 'giro'].includes(paymentMethod)) {
        return ['piutang', 'point', 'giro'].includes(val)
      }

      // if giro or card, disabled piutang, point, giro and card
      if (['giro', 'card'].includes(paymentMethod)) {
        return ['piutang', 'point', 'giro', 'card'].includes(val)
      }

      // if piutang (not success) disabled all except piutang
      if (paymentMethod === 'piutang' && !isSuccess) {
        return val !== 'piutang'
      }

      // if piutang (success) disabled piutang, point, and giro
      if (paymentMethod === 'piutang' && isSuccess) {
        return ['piutang', 'point', 'giro'].includes(val)
      }

      // if point disabled all except point
      if (paymentMethod === 'point') {
        return val !== 'point'
      }

      // default: tidak di-disable
      return false
    },
    submitCancelSplitOrders() {
      const data = this.formPayloadCancelSplitOrders.refund_method_detail
      const form = new FormData();
      data.forEach((item, index) => {
          form.append(`refund_method_detail[${index}][method]`, item.method);
          form.append(`refund_method_detail[${index}][amount]`, item.amount);
          form.append(`refund_method_detail[${index}][unpaid]`, item.unpaid);
      });
      form.append('is_split_refund', true)
      form.append('refund_method', data[0] ? data[0].method : '')
      form.append('refund_method_details', JSON.stringify(data.map(item => item.method)))
      this.isLoadingCancelOrder = true
      this.$bvModal.hide('modal-cancel-order')
      this.$store
        .dispatch("order/deleteData", {
          uuid: `${this.uuid}/delete`,
          payload: form, // Send refund method
        })
        .then(() => {
          this.isLoadingCancelOrder = false
          this.$swal({
            icon: "success",
            title: "Success!",
            text: "Order berhasil dibatalkan",
            customClass: {
              confirmButton: "btn btn-success",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              this.getData();
            }
          })
        })
        .catch((err) => {
          this.isLoadingCancelOrder = false
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
    returOrder(id) {
      this.isLoadingSortBy = true;
      this.$store
        .dispatch("order/getData", {
          uuid: `${id}/detail`,
          params: "",
        })
        .then((result) => {
          this.isLoadingSortBy = false;
          this.returData = result.data.data;
          this.$store.commit("order/setDataRetur", result.data.data);
          this.$bvModal.show("modal-retur");
        })
        .catch((err) => {
          this.isLoadingSortBy = false;
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
    goToDetail(props) {
      this.$router.push({ name: 'invoice.index', params: { id: props.row.uuid }, query: {...this.$route.query, page: this.page || 1, date: this.$route.query.date || null  } })
    },
    getData(page = this.$route.query.page || 1) {
      this.isLoading = true;
      const queryParams = { ...this.filter };
      
      if (this.$route.query.date) {
        queryParams.filter_date_type = "date";
        queryParams.filter_date_value = this.$route.query.date;
      }

      if (this.$route.query.payment_method) {
        queryParams.transactionMethod = [this.$route.query.payment_method];
      }

      // Set the page number
      queryParams.page = page;
      this.page = page;

      // Ensure paymentMethod is an array
      const paymentMethods = Array.isArray(queryParams.transactionMethod)
        ? queryParams.transactionMethod
        : [];
      delete queryParams.transactionMethod;

      // Construct the final params object
      const finalParams = {
        ...queryParams,
        ...paymentMethods.reduce((acc, method, index) => {
          acc[`payment_method[${index}]`] = method;
          return acc;
        }, {}),
      };

      this.$store
        .dispatch("order/getData", {
          uuid: "",
          params: finalParams,
        })
        .then((result) => {
          this.rows = result.data.data;
          this.items = result.data.data.data;
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response.data.meta.messages) {
            errorNotification(this, "Oops!", err.response.data.meta.messages);
            this.isLoading = false;
          }
          console.log(err);
          this.isLoading = false;
        });
    },
    detailItem(uuid) {
      this.detailRetur = {}
      this.returnUuid = uuid
      this.$bvModal.show('modal-detail-retur')
      // this.$router.push({
      //   name: 'retur.detail.index',
      //   params: { id: uuid },
      // });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.transaction {
  position: relative;

  .pagination__height {
    height: 80px;
  }

  @media screen and (min-width: 550px) {
    .pagination__height {
      height: 100%;
    }
  }

  .vgt-responsive {
    height: calc(100vh - 223px) !important;
    background-color: #fff;
  }

  .vgt-table.bordered {
    thead {
      th:last-child {
        text-align: center;
      }
    }

    td {
      border: none;
      border-bottom: 1px solid #ebe9f1;
      vertical-align: middle;
    }

    th {
      border: none;
      border-bottom: 1px solid #ebe9f1;
      color: #6b6c7e;
      font-weight: 700;
    }

    .bg-danger {

      &:hover,
      &:focus {
        background-color: #ffeef1 !important;
        box-shadow: none;
      }
    }
  }

  .page-item {
    .page-link {
      font-weight: 600;
      color: $secondary-2 !important;
      background-color: transparent;
    }

    &.active {
      .page-link {
        border-radius: 0;
        background-color: $light--1;
        font-weight: 600;
        color: $secondary-2 !important;
      }
    }
  }

  .page-item.prev-item~.page-item:nth-child(2) .page-link {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }

  .page-item.prev-item~.page-item:nth-last-child(2) .page-link {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .page-item.next-item .page-link:active,
  .page-item.next-item .page-link:hover {
    background-color: transparent !important;
  }

  .pagination__container {
    width: 100%;
    height: 80px;
    position: fixed;
    bottom: 0;
    background: #ffffff;
    box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.06);
    border: 1px solid #e4e5ec;

    .dropdown {
      button {
        font-size: 14px;
        color: $dark;
        font-weight: 600;

        &:hover {
          background-color: transparent;
        }
      }
    }

    small {
      color: $secondary-2;
      font-size: 14px;
      font-weight: 400;
    }
  }

  #dropdown-dropleft {
    .dropdown-toggle {
      border-color: transparent !important;
      background-color: transparent !important;
      color: $dark !important;

      &:hover {
        border-color: transparent !important;
        background-color: transparent !important;
        box-shadow: none !important;
      }
    }
  }

  .transaction__filter--container {
    display: flex;
    justify-content: space-between;

    .search__export {
      .search__input {
        margin-right: 8px;

        .input-group {
          width: 23.451vw;
          height: 48px;
          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);

          input {
            height: 48px;
            border: none;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
          }

          .input-group-append {
            .input-group-text {
              border-top-right-radius: 8px;
              border-bottom-right-radius: 8px;
              border: none;
            }
          }
        }
      }

      #search {
        width: 278px;
        height: 48px;
        border: none;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);
      }

      .btn.bg-white {
        border: none !important;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);
        border-radius: 8px;

        img {
          margin-right: 8px;
        }

        span {
          color: $dark;
          font-size: 14px;
          font-weight: 800;
        }
      }
    }

    .filter--button {
      border: none !important;
      color: $light--2 !important;
      background-color: transparent !important;
      border-color: transparent !important;

      &.active {
        color: $secondary !important;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          bottom: -48%;
          left: 0;
          width: 50%;
          margin-left: 25%;
          border-radius: 4px 4px 0px 0px;
          border: 2px solid $secondary;
        }
      }

      &:hover {
        box-shadow: none !important;
      }
    }
  }

  // .table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th, .table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {
  //   background-color: #fff;
  //   color: $light--description;
  //   padding: 13.5px 0px 13.5px 24px;
  // }

  // .table-responsive {
  //   background: #fff;
  //   height: 66vh;

  //   table {
  //     td {
  //       padding-top: 21px;
  //       padding-bottom: 14px;
  //       padding-left: 24px;
  //       padding-right: 0px;
  //       color: $dark;
  //       font-weight: 700;
  //       font-size: 14px;
  //     }

  //     thead {
  //       th {
  //         &:last-child {
  //           text-align: center;
  //           padding-right: 15px !important;
  //           width: 8vw;
  //         }
  //       }
  //     }
  //   }
  // }

  // .b-table-sticky-header {
  //   max-height: 66vh;
  // }
}
</style>
